import React from 'react';
import { HighlightedCriteriaView, FreshFacesView } from './Views';
import type { StrategyCodeViewProps } from 'src/components/Strategy/shared/types';

export { default as StrategyCodesList } from './StrategyCodesList';

// Strategy code types that use the StrategyCodesList component
export const STRATEGY_CODE_TYPES = [
  'SCOUT_LIST',
  'REFERRALS',
  'NOT_REFERRING',
  'FRESH_FACES',
  'TREATING_VOLUME',
] as const;

export type StrategyCodeType = typeof STRATEGY_CODE_TYPES[number];

// Registry mapping strategy types to their view components
export const STRATEGY_CODE_VIEWS: Record<
  StrategyCodeType,
  React.FC<StrategyCodeViewProps>
> = {
  SCOUT_LIST: HighlightedCriteriaView,
  REFERRALS: HighlightedCriteriaView,
  NOT_REFERRING: HighlightedCriteriaView,
  TREATING_VOLUME: HighlightedCriteriaView,
  FRESH_FACES: FreshFacesView,
};
